import { doc, updateDoc } from "firebase/firestore";

import { db } from "../firebase";

const markNotificationAsRead = async (
  userUid: string,
  notificationId: string
) => {
  // Assuming db, userUid, and notificationId are already defined
  const notificationDocRef = doc(
    db,
    `users/${userUid}/notifications`,
    notificationId
  );

  try {
    await updateDoc(notificationDocRef, {
      isRead: true,
    });
    console.log("Notification updated successfully.");
  } catch (error) {
    console.error("Error updating notification: ", error);
  }
};

export default markNotificationAsRead;
